import { Helmet } from "react-helmet"; // For SEO
import Hero from './corporate-page/Hero'
import TajBusinessConnect from './corporate-page/TajBusinessConnect'
import Special from './corporate-page/Special'
import Conference from './corporate-page/Conference'
import Membership from './Membership'
import Testimonials from './partials/Testimonials'
export default function CorporatePage() {
  
  return (
   <>


    <Helmet>
       <title>V Hotel Pass Loyalty Program - The Grand Shoba, Delhi</title>

<meta name="description" content="Join the V Hotel Pass loyalty program at The Grand Shoba in Mahipalpur, Delhi. Earn V Coins, enjoy exclusive room rates, and indulge in premium perks at our luxury hotel near IGI Airport." />
<meta name="keywords" content="V Hotel Pass, V Hotel loyalty program, earn V Coins, hotel rewards Delhi, exclusive room rates Mahipalpur, business hotel IGI Airport, luxury hotel offers, The Grand Shoba loyalty, premium hotel deals Delhi" />

{/* <!-- Open Graph (for Facebook, LinkedIn, etc.) --> */}
<meta property="og:title" content="V Hotel Pass Loyalty Program - The Grand Shoba" />
<meta property="og:description" content="Unlock exclusive hotel rewards with V Hotel Pass. Earn V Coins, save on luxury stays, and enjoy elite perks across V Hotel properties near IGI Airport, Delhi." />
<meta property="og:image" content="https://www.vhotelthegrandshoba.com/images/loyalty/loyalty-banner.jpg" />
<meta property="og:url" content="https://www.vhotelthegrandshoba.com/loyalty" />
<meta property="og:type" content="website" />

{/* <!-- Twitter Card --> */}
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:title" content="V Hotel Pass Loyalty Program - Delhi" />
<meta name="twitter:description" content="Join V Hotel Pass and enjoy exclusive rewards, V Coins, and luxury experiences at The Grand Shoba, Mahipalpur—near IGI Airport, New Delhi." />
<meta name="twitter:image" content="https://www.vhotelthegrandshoba.com/images/loyalty/loyalty-banner.jpg" />
<link rel="canonical" href="https://www.vhotelthegrandshoba.com/corporate" />
      </Helmet>
   <div className="corporate-main">
   <Hero/>
   <TajBusinessConnect/>
   <Special/>
   
   <Membership/>
   <Conference/>
   
   <Testimonials/>
   </div>
   </>
  )
}
